export default __webpack_public_path__ + "static/media/check-hover-ca.a5e6ff07.png";